import moment from "moment";
import { SERVICE_CATEGORIES } from '../../../adlevo-vue/appConfiguration';

export class CartValidationRequest
{
    constructor(carTData)
    {
        this.cartData = carTData;
    }

    buildRequest()
    {
        const cartRequestPayload = {
            tours: {},
            hotels: {
                "items": []
            }
        };

        this.cartData.forEach(cartItem => {
            switch (cartItem.type) {
                case SERVICE_CATEGORIES.ACTIVITIES:
                    cartRequestPayload.tours = {
                        ...cartRequestPayload.tours,
                        ...cartItem.toRequestPayloadForValidateItems()
                    };
                    break;
                case SERVICE_CATEGORIES.HOTELS:
                    cartRequestPayload.hotels.items.push(...cartItem.toRequestPayloadForValidateItems())
                    break;
            }
        });
        return cartRequestPayload;
    }
}
